<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject">step 2 | choose your letter height</div>
    <div class="step-wrapper-description mt-4">Remember when choosing the letter height that the measurement indicates the distance from baseline to cap-height (indicated in red in the figure below):.</div>
    <div class="step-wrapper-description mt-4">If you are ordering lowercase letters, please order the size based on the capital height measurement.</div>
    <div class="step-wrapper-description mt-4">
      <img :src="helpImg" />
    </div>

    <b-form-select v-model="stencileaseTextHeight" :optionsOrig="optionsOrig" :options="options" class="mt-4" @change.native="changeLetterHeight" />
      <b-button variant="default" class="mt-4 go-next" v-on:click="goNext">next</b-button>
  </div>
</template>

<script>
import jQuery from 'jquery'

export default {
  components: {
    jQuery
  },
  data() {
    return {
      stencileaseTextHeight: this.$store.state.product.textHeight,
      optionsOrig: [
        { value: '3', text: '3"' },
        { value: '4', text: '4"' },
        { value: '4.5', text: '4.5"' },
        { value: '5', text: '5"' },
        { value: '5.5', text: '5.5"' },
        { value: '6', text: '6"' },
        { value: '6.5', text: '6.5"' },
        { value: '7', text: '7"' },
        { value: '7.5', text: '7.5"' },
        { value: '8', text: '8"' },
        { value: '8.5', text: '8.5"' },
        { value: '9', text: '9"' },
        { value: '9.5', text: '9.5"' },
        { value: '10', text: '10"' },
        { value: '10.5', text: '10.5"' },
        { value: '11', text: '11"' },
        { value: '11.5', text: '11.5"' },
        { value: '12', text: '12"' },
        { value: '12.5', text: '12.5"' },
        { value: '13', text: '13"' },
        { value: '14', text: '14"' },
        { value: '15', text: '15"' },
        { value: '16', text: '16"' },
        { value: '17', text: '17"' },
        { value: '18', text: '18"' },
        { value: '19', text: '19"' },
        { value: '20', text: '20"' },
        { value: '21', text: '21"' },
        { value: '22', text: '22"' },
        { value: '23', text: '23"' },
        { value: '24', text: '24"' },
        { value: '25', text: '25"' },
        { value: '26', text: '26"' },
        { value: '27', text: '27"' },
        { value: '28', text: '28"' },
        { value: '29', text: '29"' },
        { value: '30', text: '30"' },
        { value: '31', text: '31"' },
        { value: '32', text: '32"' },
        { value: '33', text: '33"' },
        { value: '34', text: '34"' },
        { value: '35', text: '35"' },
        { value: '36', text: '36"' },
        { value: '37', text: '37"' },
        { value: '38', text: '38"' },
        { value: '39', text: '39"' },
        { value: '40', text: '40"' },
        { value: '41', text: '41"' },
        { value: '42', text: '42"' },
        { value: '43', text: '43"' },
        { value: '44', text: '44"' },
        { value: '45', text: '45"' },
        { value: '46', text: '46"' },
        { value: '47', text: '47"' },
        { value: '48', text: '48"' },
        { value: '49', text: '49"' },
        { value: '50', text: '50"' },
        { value: '51', text: '51"' },
        { value: '52', text: '52"' },
        { value: '53', text: '53"' },
        { value: '54', text: '54"' },
        { value: '55', text: '55"' },
        { value: '56', text: '56"' },
        { value: '57', text: '57"' },
        { value: '58', text: '58"' },
        { value: '59', text: '59"' },
        { value: '60', text: '60"' },
        { value: '61', text: '61"' },
        { value: '62', text: '62"' },
        { value: '63', text: '63"' },
        { value: '64', text: '64"' },
        { value: '65', text: '65"' },
        { value: '66', text: '66"' },
        { value: '67', text: '67"' },
        { value: '68', text: '68"' },
        { value: '69', text: '69"' },
        { value: '70', text: '70"' },
        { value: '71', text: '71"' },
        { value: '72', text: '72"' },
        { value: '73', text: '73"' },
        { value: '74', text: '74"' },
        { value: '75', text: '75"' },
        { value: '76', text: '76"' },
        { value: '77', text: '77"' },
        { value: '78', text: '78"' },
        { value: '79', text: '79"' },
        { value: '80', text: '80"' },
        { value: '81', text: '81"' },
        { value: '82', text: '82"' },
        { value: '83', text: '83"' },
        { value: '84', text: '84"' },
        { value: '85', text: '85"' },
        { value: '86', text: '86"' },
        { value: '87', text: '87"' },
        { value: '88', text: '88"' },
        { value: '89', text: '89"' },
        { value: '90', text: '90"' },
        { value: '91', text: '91"' },
        { value: '92', text: '92"' },
        { value: '93', text: '93"' },
        { value: '94', text: '94"' },
        { value: '95', text: '95"' },
        { value: '96', text: '96"' },
        { value: '97', text: '97"' },
        { value: '98', text: '98"' },
        { value: '99', text: '99"' },
        { value: '100', text: '100"' },
        { value: '101', text: '101"' },
        { value: '102', text: '102"' },
        { value: '103', text: '103"' },
        { value: '104', text: '104"' },
        { value: '105', text: '105"' },
        { value: '106', text: '106"' },
        { value: '107', text: '107"' },
        { value: '108', text: '108"' }
      ]
    }
  },
  computed: {
    helpImg() {
      return jQuery('#__stencilease-lc-letter-helper-img').attr('src')
    },
    options() {
      let material = this.$store.state.product.material
      let options = []

      for(var i=0; i< this.optionsOrig.length; i++) {
        let item = this.optionsOrig[i];

        if (item.value > 72) { continue; }

        options[i] = item
      }
      return options
    }
  },
  methods: {
    changeLetterHeight(evt) {
      this.$store.dispatch('product/SET_HEIGHT', evt.target.value)
    },
    goNext(evt) {
      this.$store.dispatch('product/SET_OLDTAB', 1)

      this.$store.dispatch('product/SET_ACTIVETAB', 1)
      this.$store.dispatch('product/SET_ACTIVETAB', 2)
    }
  }
}
</script>
